import { render, staticRenderFns } from "./element-input-currency-amount.vue?vue&type=template&id=7afa7da2&scoped=true"
import script from "./element-input-currency-amount.vue?vue&type=script&lang=js"
export * from "./element-input-currency-amount.vue?vue&type=script&lang=js"
import style0 from "./element-input-currency-amount.vue?vue&type=style&index=0&id=7afa7da2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7afa7da2",
  null
  
)

export default component.exports